import React, { useEffect, useState, Suspense } from 'react';
import classNames from 'classnames';
import { arrayOf, shape, string } from 'prop-types';
import { Button, Image } from '@thd-olt-component-react/core-ui';
import {
  useDataModel,
  params,
  arrayOf as arrayType,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { StoreLayoutOverlay } from './StoreLayoutOverlay';
import { ready } from '../helper';
import './aisle-bay-find-most.scss';

export const AisleBayFindMost = ({ itemId, store, products }) => {
  const { storeId, storeName } = store || {};
  const storeSkuIds = (products || []).map((product) => product.identifiers?.storeSkuNumber)
    .filter((sku) => !!sku);
  const [storeOverlayOpen, setStoreOverlayOpen] = useState(false);

  const aisleBayResponse = useDataModel('aislebay', {
    skip: !storeSkuIds.length || !storeId || !storeName,
    ssr: false,
    variables: {
      storeId,
      storeSkuIds,
    }
  });

  useEffect(() => {
    ready('aisle-bay-find-most');
  }, []);

  const { aislebay } = aisleBayResponse.data || {};
  const { storeSkus = [] } = aislebay || {};

  if (!storeSkuIds.length || (aislebay && !storeSkus.length)) {
    return null;
  }

  const counts = {};
  let mostCommonAisle = { count: 0, aisle: '' };
  storeSkus.forEach((sku) => {
    const { aisleBayInfo } = sku;
    const { aisle, bay } = aisleBayInfo || {};
    if (!(aisle && bay)) {
      return;
    }
    counts[aisle] = counts[aisle] ? counts[aisle] + 1 : 1;
    mostCommonAisle = counts[aisle] > mostCommonAisle.count
      ? { ...aisleBayInfo, count: counts[aisle] }
      : mostCommonAisle;
  });

  const shouldBeHidden = !storeName || !mostCommonAisle.aisle;

  const aisleBayFindMostClasses = classNames('aisle-bay-find-most', {
    'aisle-bay-find-most--hidden': shouldBeHidden
  });

  const onStoreLayoutClick = () => {
    setStoreOverlayOpen(true);
  };

  return (
    <>
      <Button onClick={onStoreLayoutClick} link data-component="AisleBayFindMost">
        <Image
          src="https://assets.thdstatic.com/images/v1/poi-outline.svg"
          alt="Location Pin"
          className="aisle-bay-find-most__icon"
          width="22"
          height="28"
        />
        <div className="aisle-bay-find-most__text">
          <span>Find most of these in&nbsp;
            <span className="u__bold">
              Aisle {mostCommonAisle.aisle} at {storeName} Store
            </span>
          </span>
          <span className="aisle-bay-find-most__text--primary">Tap to see on store map</span>
        </div>
        <Image src="https://assets.thdstatic.com/images/v1/next-arrow-orange.svg" alt="Arrow Right" />
      </Button>
      {storeOverlayOpen && (
        <StoreLayoutOverlay
          onLayoutClick={setStoreOverlayOpen}
          storeId={storeId}
          storeName={storeName}
          aislebay={mostCommonAisle}
        />
      )}
    </>
  );

};

AisleBayFindMost.displayName = 'AisleBayFindMost';

AisleBayFindMost.propTypes = {
  itemId: string,
  products: arrayOf(shape({})).isRequired,
  store: shape({
    storeId: string,
    storeName: string,
  }).isRequired
};

AisleBayFindMost.dataModel = {
  aislebay: params({
    storeId: stringType().isRequired(),
    storeSkuIds: arrayType(stringType().isRequired())
  }).shape({
    storeSkus: arrayType(shapeType({
      storeNumber: stringType(),
      storeSkuId: stringType(),
      aisleBayInfo: shapeType({
        aisle: stringType(),
        bay: stringType(),
        invLocDesc: stringType()
      })
    }))
  }),
};

AisleBayFindMost.defaultProps = {
  itemId: null
};
